import msContent from "@/content/i18n/ms.json";
import zhContent from "@/content/i18n/zh.json";
import { type TranslatedLocale } from "@/lib/i18n";
import { type LocalizedRouteKey } from "@/lib/localized-routes";

export interface LocalizedPageContent {
  eyebrow: string;
  title: string;
  intro: string;
  summary: string;
  highlights: string[];
  seoKeywords?: string[];
  sections: {
    title: string;
    body: string;
  }[];
  ctaTitle: string;
  ctaDescription: string;
  ctaButton: string;
}

// Partial by design: only content-rich marketing routes carry pages entries in
// ms.json/zh.json (22 of 60+ today). The old non-partial Record was already
// untrue at runtime and broke TS overlap checks whenever routes were added.
type PageContentByRoute = Partial<Record<LocalizedRouteKey, LocalizedPageContent>>;

const localizedPages = {
  ms: msContent.pages as PageContentByRoute,
  zh: zhContent.pages as PageContentByRoute,
} satisfies Record<TranslatedLocale, PageContentByRoute>;

export function getLocalizedPageContent(
  route: LocalizedRouteKey,
  locale: TranslatedLocale,
): LocalizedPageContent {
  // Callers are components whose routes are guaranteed present in the JSON.
  return localizedPages[locale][route]!;
}

export function getLocalizedPageSeoKeywords(
  route: LocalizedRouteKey,
  locale: TranslatedLocale,
): string[] | undefined {
  return localizedPages[locale][route]?.seoKeywords;
}
